import store from "@src/reducers/store";
import {
  updateLicensedConfigurationsError,
  updateLicensedConfigurationsLoaded,
  updateLicensedConfigurationsLoading,
} from "@src/reducers/your-reducer";
import fetchLicensedConfigurations from "../api/use-cases/fetch-licensed-configurations";

const loadLicensedConfigurations = async () => {
  store.dispatch(updateLicensedConfigurationsLoading());
  try {
    const licensedConfigurations = await fetchLicensedConfigurations();
    store.dispatch(updateLicensedConfigurationsLoaded(licensedConfigurations));
  } catch (error) {
    store.dispatch(updateLicensedConfigurationsError(error));
  }
};

export default loadLicensedConfigurations;
